import React, { useEffect, useState } from 'react'
import ClipLoader from "react-spinners/ClipLoader";
import { SubmitForgotPassword} from '../api/auth'
import { Formik } from "formik";
import * as Yup from "yup";
import { Form, Alert } from 'react-bootstrap'

const schema = Yup.object().shape({
    email: Yup.string()
        .required("Email is a required field")
        .email("Invalid email format"),

});

export default function ForgotPassword(props){

        const [resetError, setResetError] = useState(null);
        const [resetSuccess, setResetSuccess] = useState(null);
        const [submitting, setSubmitting] = useState(false);

    return(
        <>

        <Formik
            validationSchema={schema}
            initialValues={{ email: "" }}
            onSubmit={async (values) => {
                setSubmitting(true);
                setResetError(null);
                setResetSuccess(null);
                let _reset = await SubmitForgotPassword(values);
                if (_reset.Code === 0) {
                    setResetSuccess(`Please check your email for instructions on setting a new password.`)
                }else if(_reset.Code === 3){
                    setResetError(`We could not find an account for this email address. Please try another email address.`);
                } else {
                    setResetError(_reset.error_message ?? `There was an issue recovering.  Please try again later.`);
                }
                setSubmitting(false);

            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <div className="login">
                    <h2>Reset Password</h2>
                    <p>Please provide your email address, and we will send you instructions on how to set a new password.</p>
                    <div className="form">
                        {resetError && <Alert transition={null} variant={'danger'}>{resetError}</Alert>}
                        {resetSuccess && <Alert transition={null} variant={'success'}>{resetSuccess}</Alert>}
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group controlId="email" className={`col-md-10`}>
                                <Form.Label>Email Address</Form.Label>
                                <Form.Control type="email" value={values.email} placeholder={`Email Address`} name={"email"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.email}></Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    {errors.email && touched.email && errors.email}
                                </Form.Control.Feedback>
                            </Form.Group>

                          
                            <button type="submit" class={`gc-btn primary-action`}>Recover {submitting && <ClipLoader size={`18`} color={`#fff`} />}</button>
                        </Form>

                    </div>
                </div>
            )}
        </Formik>
        </>
    )
}

